import React, { useState } from "react";
import imageCompression from "browser-image-compression";

const API_URL = "https://atipn-backend.onrender.com";

export const Gallery = () => {
  const [type, setType] = useState("connection");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const notify = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 3000);
  };

  const handleTypeChange = (newType) => {
    setType(newType);
    setImagePreview(null);
    setImageFile(null);
    setUploadProgress(0);
  };

  /* ===============================
     IMAGE COMPRESSION (CLIENT SIDE)
     =============================== */
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    notify("Optimizing image...");

    const options = {
      maxSizeMB: 1,           // target size
      maxWidthOrHeight: 1600, // dashboard quality
      useWebWorker: true,
      initialQuality: 0.85,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      setImageFile(compressedFile);
      setImagePreview(URL.createObjectURL(compressedFile));
    } catch (err) {
      notify("Image optimization failed ❌");
    }
  };

  /* ===============================
     FORM SUBMIT WITH PROGRESS BAR
     =============================== */
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("type", type);
    formData.append("name", e.target.name.value);
    formData.append("mobile", e.target.mobile.value);
    formData.append("email", e.target.email.value);

    if (type === "connection") {
      formData.append("address", e.target.address.value);
    } else {
      formData.append("issue", e.target.issue.value);
      if (imageFile) formData.append(
  "image",
  imageFile,
  imageFile.name || "complaint.jpg"
);
    }

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${API_URL}/api/inquiry`);

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        setUploadProgress(percent);
      }
    };

    xhr.onload = () => {
  setLoading(false);
  setUploadProgress(0);

  if (xhr.status >= 200 && xhr.status < 300) {
    notify("Submitted successfully ✅");
    e.target.reset();
    setImagePreview(null);
    setImageFile(null);
  } else {
    console.error("Upload failed:", xhr.responseText);
    notify("Submission failed ❌");
  }
};


    xhr.onerror = () => {
      setLoading(false);
      notify("Server error ❌");
    };

    xhr.send(formData);
  };

  return (
    <section className="contact-modern" id="gallery">
      {toast && <div className="toast">{toast}</div>}

      <div className="container">
        <div className="section-title text-center">
          <h2>Contact Us</h2>
          <p>New connection enquiry or raise a complaint</p>
        </div>

        <div className="toggle-pill">
          <span
            className={type === "connection" ? "active" : ""}
            onClick={() => handleTypeChange("connection")}
          >
            New Connection
          </span>
          <span
            className={type === "complaint" ? "active" : ""}
            onClick={() => handleTypeChange("complaint")}
          >
            Complaint
          </span>
        </div>

        <div className="form-card">
          <form onSubmit={handleSubmit}>
            <input type="hidden" name="type" value={type} />

            <input name="name" placeholder="Full Name" required />
            <input name="mobile" placeholder="Mobile Number" required />
            <input
              name="email"
              type="email"
              placeholder="Email Address"
              required
            />

            {type === "connection" ? (
              <textarea name="address" placeholder="Address" required />
            ) : (
              <>
                <textarea
                  name="issue"
                  placeholder="Describe your issue"
                  required
                />

                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={handleImageChange}
                />

                {imagePreview && (
                  <>
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        width: "120px",
                        marginTop: "10px",
                        borderRadius: "8px",
                      }}
                    />

                    {uploadProgress > 0 && (
                      <div className="upload-bar">
                        <div style={{ width: `${uploadProgress}%` }} />
                      </div>
                    )}
                  </>
                )}
              </>
            )}

            <button disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
